/**
 *
 * @param color - A color string that may be in hex format (3, 6, or 8 digits) or a named color.
 * @returns Return correct format for hex colors by adding a '#' prefix if missing.
 */
export function formatColorName(color: string): string {
  const finalColor =
    /^[0-9a-fA-F]{3,8}$/.test(color) && !color.startsWith("#")
      ? `#${color}`
      : color;
  return finalColor;
}
